import { CurrencyView } from '../currency-view';
import { FAUCET_ENABLED } from '@/client/confs/app';
import { useSingerTokenBalance } from '@/client/hooks/use-signed-token-balance';
import { useAppSettingStore } from '@/client/store/app-store';
import { useModelStore } from '@/client/store/model-store';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { Droplets } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const WalletBalance = () => {
  const { t } = useTranslation();
  const setFaucetOpen = useModelStore(state => state.setFaucetOpen);
  const baseToken = useAppSettingStore(state => state.baseToken);
  const tokenBalances = useSingerTokenBalance(api);
  const tokenBalance = tokenBalances.data?.find(item => item.baseTokenAddress === baseToken.address);
  return (
    <div
      style={{ backgroundImage: baseToken.img ? `url(${baseToken.img})` : undefined }}
      className={cn(
        'p-4 rounded-4 border space-y-3 flex flex-col min-h-[140px]',
        'transition-all duration-500 bg-cover bg-no-repeat bg-[position:center]'
      )}
    >
      {/* Wallet balance (on-chain, self-custody — no Deposit/Withdraw) */}
      <div className="space-y-3 flex-1 text-main-foreground">
        <div className="flex items-center justify-between">
          <h4 className="font-semibold leading-[normal]">{t('wallet-balance', 'Wallet Balance')}</h4>
          {FAUCET_ENABLED && (
            <button
              type="button"
              onClick={() => setFaucetOpen(true)}
              className="flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium cursor-pointer border border-main-foreground/20 text-main-foreground/80 hover:text-main-foreground transition-colors"
            >
              <Droplets className="size-3.5" />
              {t('faucet', 'Faucet')}
            </button>
          )}
        </div>
        {/* isPending (not isLoading) + no-data => spinner: a disabled or
            failing on-chain read must never render as a real "0" balance */}
        <CurrencyView
          animated={true}
          showUnit={true}
          className="font-bold text-8 leading-none items-end"
          isLoading={tokenBalances.isPending || !tokenBalance}
          value={tokenBalance?.balance}
          decimal={tokenBalance?.baseTokenDecimals}
          unitClassName="text-xl text-main-foreground/40 leading-[normal]"
        />
      </div>
    </div>
  );
};
